import { Component, OnInit } from '@angular/core';
import { color, language, ModalBase, notification } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';

@Component({
    selector: 'task-create-edit-location-dialog',
    template: `
        <task-create-edit-location [location]="location" (result)="handle_result($event)"></task-create-edit-location>
    `
})
export class CreateEditLocationDialog extends ModalBase<Task.Location, Task.Location> implements OnInit {
    preventSoftClose = true;
    location: Task.Location;

    ngOnInit() {
        this.location = this.injectedData;
    }

    handle_result(loc: Task.Location) {
        if (loc) {
            let prom;
            let req: any = { ...loc };
            
            if (loc.location_users && loc.location_users.length > 0) {
                req.user_ids = loc.location_users.map(u => u.user_id);
            }

            if (!loc.location_id) {
                prom = TaskRoutes.locations.api_location_add(req).then(async (res: any) => {
                    let new_location_id = res.location_id.location_id;

                    try {
                        for (let meter of req.pending_meters || []) {
                            await TaskRoutes.meters.api_meter_add({
                                code: meter.code,
                                brand: meter.brand,
                                meter_type_id: meter.meter_type_id,
                                location_id: new_location_id
                            });
                        }
                    } catch {
                        notification.show({
                            icon: 'error',
                            color: color.Variable.warn,
                            title: language.translate('ERROR'),
                            message: language.translate('METERS.SAVE_FAILED')
                        });
                    }
                });
            } else {
                prom = TaskRoutes.locations.api_location_modify(loc.location_id, req);
            }

            prom.then( res => {
                this.submit(loc);
            }).catch(error => {
                if (error.internal_error_code === 4105) {
                    notification.show({
                        icon: 'error',
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: language.translate('LOCATION.ERROR_INTERNAL_TAG')
                    });
                } else {
                    notification.show({
                        icon: 'error',
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: ''
                    });
                }
            });
        } else {
            this.submit(loc);
        }
    }
}
